<template>
    <div class="animated fadeIn">
        <b-container class="w-100 px-0" v-if="provinces">
            <b-row class="m-0 py-2 px-2 w-100">
                <div class="w-100">
                    <b-row class="bg-light m-0 p-3">
                        <b-col md="12">
                            <b-row class="p-0 mb-4">
                                <h5 class="border-bottom mb-2 text-primary w-100">DATOS PERSONALES</h5>

                                <b-row class="w-100 px-0 mb-2">
                                    <b-col md="4">
                                        <b-form-group
                                            label="<strong>CIF</strong>"
                                            label-for="companyNif"
                                            :horizontal="false"
                                            class="w-100 mb-0">
                                            <b-form-input
                                                id="companyNif"
                                                name="companyNif"
                                                type="text"
                                                placeholder="CIF"
                                                v-model="entity.companyNif"
                                                class="w-100"
                                                v-validate="'nif'"
                                                :state="validateState('companyNif')"
                                                aria-describedby="check_companyNif"></b-form-input>
                                            <div class="text-danger text-right" id="check_companyNif">
                                                <small>{{ errors.first('companyNif') }}</small>
                                            </div>
                                        </b-form-group>
                                    </b-col>

                                    <b-col md="4">
                                        <b-form-group
                                            label="<strong>Empresa</strong>"
                                            label-for="companyName"
                                            :horizontal="false"
                                            class="w-100 mb-0">
                                            <b-form-input
                                                id="companyName"
                                                name="companyName"
                                                type="text"
                                                placeholder="Empresa"
                                                v-model="entity.companyName"
                                                class="w-100"
                                                v-validate="'min:3'"
                                                :state="validateState('companyName')"
                                                aria-describedby="check_companyName"></b-form-input>
                                            <div class="text-danger text-right" id="check_companyName">
                                                <small>{{ errors.first('companyName') }}</small>
                                            </div>
                                        </b-form-group>
                                    </b-col>

                                    <b-col md="4">
                                        <b-form-group
                                            label="<strong>Nº Trabajadores</strong>"
                                            label-for="companyWorkersNumber"
                                            :horizontal="false"
                                            class="w-100 mb-0">
                                            <b-form-input
                                                id="companyWorkersNumber"
                                                name="companyWorkersNumber"
                                                type="number"
                                                placeholder="Nº Trabajadores"
                                                v-model="entity.companyWorkersNumber"
                                                class="w-100"
                                                v-validate="'integer'"
                                                :state="validateState('companyWorkersNumber')"
                                                aria-describedby="check_companyWorkersNumber"></b-form-input>
                                            <div class="text-danger text-right" id="check_companyWorkersNumber">
                                                <small>{{ errors.first('companyWorkersNumber') }}</small>
                                            </div>
                                        </b-form-group>
                                    </b-col>
                                </b-row>

                                <b-row class="w-100 px-0 mb-0">
                                    <b-col md="4">
                                        <b-form-group
                                            label="<strong>Fecha Alta ATA *</strong>"
                                            label-for="registeredAt"
                                            :horizontal="false"
                                            class="w-100 mb-0">
                                            <v-date-picker v-model='entityRegisteredAtFormatted' :max-date="new Date()" popoverDirection="top">
                                                <template v-slot="{ inputValue, inputEvents }">
                                                    <b-form-input
                                                        :value="inputValue"
                                                        v-on="inputEvents"
                                                        id="registeredAt"
                                                        name="registeredAt"
                                                        class="w-100"
                                                        v-validate="{required: true, registeredAt: {autonomousRegisteredAt: entity.autonomousRegisteredAt}}"
                                                        :state="validateState('registeredAt')"
                                                        aria-describedby="check_registeredAt" />
                                                </template>
                                            </v-date-picker>
                                            <div class="text-danger text-right" id="check_registeredAt">
                                                <small>{{ errors.first('registeredAt') }}</small>
                                            </div>
                                        </b-form-group>
                                    </b-col>

                                    <b-col md="4">
                                        <b-form-group
                                            label="<strong>Modelo de Gestión</strong>"
                                            label-for="managementModel"
                                            :horizontal="false"
                                            class="w-100 mb-0">
                                            <multiselect
                                                id="managementModel"
                                                v-model="entity.managementModel"
                                                :options="managementModels.map(option => option.value)"
                                                :customLabel="value => (managementModels.find(option => option.value === value).text)"
                                                :multiple="false"
                                                :allowEmpty="true"
                                                placeholder="Seleccione"
                                                selectedLabel=""
                                                selectLabel=""
                                                deselectLabel="">
                                            </multiselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </b-row>
                            <b-row class="p-0 mb-0">
                                <h5 class="border-bottom mb-2 w-100 text-primary">
                                    DIRECCIONES Y VÍAS DE CONTACTO
                                </h5>
                                <location-form
                                    :initial-province="tempData.province"
                                    :initial-town="tempData.town"
                                    :initial-postal-code="tempData.postalCode"
                                    :community-show="true"
                                    :communityRequired="false"
                                    :provinceRequired="true"
                                    :townRequired="true"
                                    :postalCodeRequired="true"
                                    :input-size="'4'"
                                    @province-change="province => {tempData.province = province}"
                                    @town-change="town => {tempData.town = town}"
                                    @postal-code-change="postalCode => {tempData.postalCode = postalCode}"
                                    @address-change="address => {tempData.address = address}">
                                </location-form>
                                <b-row class="w-100 px-0 mb-2">
                                    <b-col md="8">
                                        <!-- ////////////////////// Dirección ////////////////////// !-->
                                        <b-form-group
                                            label="<strong>Dirección *</strong>"
                                            label-for="address"
                                            :horizontal="false"
                                            class="w-100 mb-0">
                                            <b-form-input
                                                id="address"
                                                name="address"
                                                type="text"
                                                placeholder="Dirección"
                                                v-model="tempData.address"
                                                class="w-100"
                                                v-validate="'required|min:3'"
                                                :state="validateState('address')"
                                                aria-describedby="check_address"></b-form-input>
                                            <div class="text-danger text-right" id="check_address">
                                                <small>{{ errors.first('address') }}</small>
                                            </div>
                                        </b-form-group>
                                        <!-- !-->
                                    </b-col>
                                </b-row>
                                <b-row class="w-100 px-0 mb-2">
                                    <b-col md="8">
                                        <!-- ////////////////////// Emails ////////////////////// !-->
                                        <b-form-group
                                            label="<strong>Emails *</strong>"
                                            label-for="email"
                                            :horizontal="false"
                                            class="w-100 mb-0">
                                            <b-form-input
                                                id="email"
                                                name="email"
                                                type="text"
                                                placeholder="Introduzca Email y pulse intro"
                                                class="w-100"
                                                @keypress.enter.native="addEmail($event.target.value)"
                                                v-validate="'email'"
                                                :state="validateState('email')"
                                                aria-describedby="check_email"
                                                v-model="email"
                                                autocomplete="nope"></b-form-input>
                                            <div class="text-danger text-right" id="check_email">
                                                <small>{{ errors.first('email') }}</small>
                                            </div>
                                        </b-form-group>
                                        <!-- !-->
                                        <b-list-group>
                                            <b-list-group-item
                                                v-for="(email, index) in entity.emails"
                                                :key="index">{{ email.email }}
                                                <template v-if="email.main">
                                                    <b-badge
                                                        variant="primary"
                                                        class="float-right"
                                                        pill>Principal
                                                    </b-badge>
                                                </template>
                                                <template v-else>
                                                    <b-badge
                                                        variant="secondary"
                                                        class="float-right"
                                                        pill>Secundario
                                                    </b-badge>
                                                </template>

                                                <div @click="changeEmailStatus(email.email)">
                                                    <template v-if="email.status == 'ACTIVE'">
                                                        <b-badge
                                                            variant="success"
                                                            class="float-right"
                                                            pill>ACTIVO
                                                        </b-badge>
                                                    </template>
                                                    <template v-else-if="email.status == 'UNWANTED'">
                                                        <b-badge
                                                            variant="warning"
                                                            class="float-right"
                                                            pill>NO DESEA
                                                        </b-badge>
                                                    </template>
                                                    <template v-else>
                                                        <b-badge
                                                            variant="danger"
                                                            class="float-right"
                                                            pill>ERRONEO
                                                        </b-badge>
                                                    </template>
                                                </div>
                                                <div @click="removeEmail(email.email)">
                                                    <template>
                                                        <b-badge
                                                            variant="danger"
                                                            class="float-left"
                                                            pill>Borrar
                                                        </b-badge>
                                                    </template>
                                                </div>

                                            </b-list-group-item>
                                        </b-list-group>
                                    </b-col>
                                    <b-col md="4">
                                        <!-- ////////////////////// Teléfonos ////////////////////// !-->
                                        <b-form-group
                                            label="<strong>Teléfonos *</strong>"
                                            label-for="phone"
                                            :horizontal="false"
                                            class="w-100  mb-0">
                                            <b-form-input
                                                id="phone"
                                                name="phone"
                                                type="text"
                                                placeholder="Introduzca Teléfono y pulse intro"
                                                class="w-100"
                                                @keypress.enter.native="addPhone($event.target.value)"
                                                v-validate="getValidateRulesForArrayField('phones', {required: true, phone: true})"
                                                :state="validateState('phone')"
                                                aria-describedby="check_phone"
                                                v-model="phone"
                                                autocomplete="nope"></b-form-input>
                                            <div class="text-danger text-right" id="check_phone">
                                                <small>{{ errors.first('phone') }}</small>
                                            </div>
                                        </b-form-group>
                                        <!-- !-->
                                        <b-list-group>
                                            <b-list-group-item
                                                v-for="(phone,index) in entity.phones"
                                                :key="index">{{ phone.phone }}
                                                <div @click="removePhone(phone.phone)">
                                                    <template>
                                                        <b-badge
                                                            variant="danger"
                                                            class="float-left"
                                                            pill>Borrar
                                                        </b-badge>
                                                    </template>
                                                </div>
                                            </b-list-group-item>
                                        </b-list-group>
                                    </b-col>
                                </b-row>
                                <b-row class="w-100 mt-2">
                                  <b-col sm="12" md="12">
                                    <b-form-group
                                      label="<strong>Preferencias en Comunicaciones dadas de baja</strong>"
                                      label-for="unsubscribe"
                                      :horizontal="false"
                                      class="w-100">
                                      <multiselect
                                        name="unsubscribe"
                                        v-model="entity.campaignTypes"
                                        :options="campaignTypes"
                                        track-by="uuid"
                                        label="name"
                                        :multiple="true"
                                        :allowEmpty="true"
                                        selectLabel="+"
                                        deselectLabel="-">
                                      </multiselect>
                                      <template slot="label" slot-scope="{ option }">
                                        {{ option.name }}
                                      </template>
                                    </b-form-group>
                                  </b-col>
                                </b-row>
                                <b-row class="w-100 mt-2">
                                    <b-col md="8">
                                        <b-form-checkbox
                                            type="checkbox"
                                            stacked
                                            v-model="entity.shareDataToThirdParties">Consiente la Cesión de sus datos a Terceros (LOPD)
                                        </b-form-checkbox>
                                    </b-col>
                                    <b-col md="4">
                                        <a
                                            href="#"
                                            @click="alternative = !alternative"
                                            class="text-decoration-none mt-0 mb-0 float-right"
                                            v-show="!alternative">
                                            <strong>+Añadir Dirección</strong>
                                        </a>
                                    </b-col>
                                </b-row>
                            </b-row>
                            <b-row class="p-0 mt-4 mb-0" v-show="alternative">
                                <h5 class="border-bottom mb-2 text-primary w-100">DIRECCIÓN POSTAL ALTERNATIVA</h5>
                                <b-row class="w-100 px-0 mb-2">
                                    <b-col md="8">
                                        <!-- ////////////////////// Nombre ////////////////////// !-->
                                        <b-form-group
                                            label="<strong>Nombre</strong>"
                                            label-for="name2"
                                            :horizontal="false"
                                            class="w-100 mb-0">
                                            <b-form-input
                                                id="name2"
                                                name="name2"
                                                type="text"
                                                placeholder="Nombre"
                                                v-model="tempData2.name"
                                                class="w-100"
                                                v-validate="'required|min:3'"
                                                :state="validateState('name')"
                                                aria-describedby="check_name"></b-form-input>
                                            <div class="text-danger text-right" id="check_name">
                                                <small>{{ errors.first('name2') }}</small>
                                            </div>
                                        </b-form-group>
                                        <!-- !-->
                                    </b-col>
                                </b-row>
                                   <location-form
                                        :provinceRequired="true"
                                        :townRequired="true"
                                        :postalCodeRequired="true"
                                        :community-show="true"
                                        :community-required="false"
                                        :input-size="'4'"
                                        @province-change="province => {tempData.province = province}"
                                        @town-change="town => {tempData.town = town}"
                                        @postal-code-change="postalCode => {tempData.postalCode = postalCode}"
                                        @address-change="address => {tempData.address = address}"></location-form>
                                <b-row class="w-100 px-0 mb-2">
                                    <b-col md="8">
                                        <!-- ////////////////////// Dirección ////////////////////// !-->
                                        <b-form-group
                                            label="<strong>Dirección</strong>"
                                            label-for="address2"
                                            :horizontal="false"
                                            class="w-100 mt-2 mb-0">
                                            <b-form-input
                                                id="address2"
                                                name="address2"
                                                type="text"
                                                placeholder="Dirección"
                                                v-model="tempData2.address"
                                                class="w-100"></b-form-input>
                                        </b-form-group>
                                        <!-- !-->
                                    </b-col>
                                    <b-col md="4">
                                    </b-col>
                                </b-row>
                            </b-row>
                        </b-col>
                    </b-row>
                    <b-row class="pt-4 m-0 pb-0">
                        <div class="px-0 col float-left">
                            <button
                                v-if="mixinCheckPermission('EDIT_MEMBER_PERSONAL_DATA')"
                                class="btn btn-brand btn-primary btn-lg pull-right"
                                :disabled="!validate()"
                                @click="store">Guardar
                            </button>
                        </div>
                    </b-row>
                </div>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import {request} from '@/helpers/services';
import Multiselect from 'vue-multiselect';
import {DatePicker, setupCalendar} from 'v-calendar';
import form from '@/helpers/form';
import {getManagementModelsOptions} from '@/helpers/client-helper';
import moment from 'moment';
import LocationForm from '@/components/location/LocationForm';

import 'v-calendar/lib/v-calendar.min.css';

setupCalendar({
        firstDayOfWeek: 2,// Monday
    });

    export default {
        name: 'addPartners',
        components: {
            'v-date-picker': DatePicker,
            Multiselect,
            LocationForm
        },
        props: ['partner', 'campaignTypes'],
        data: function () {
            return {
                topmenu: [
                    {name: 'Volver', path: '/admin/agreements/list', brand: 'fa fa-arrow-left'},
                ],
                title: 'Nuevo Socio',
                subtitle: 'Paso 2 de 4',
                entity: {
                    emails: [],
                    phones: [],
                    addresses: [],
                    managementModel: null,
                    shareDataToThirdParties: false,
                    registeredAt: null,
                    companyWorkersNumber: 0,
                    companyNif: "",
                    companyName: "",
                    memberId: null,
                    campaignTypes: []
                },
                tempData: {
                    name: "",
                    province: "",
                    town: "",
                    address: "",
                    postalCode: "",
                },
                tempData2: {
                    name: null,
                    province: null,
                    town: null,
                    address: null,
                    postalCode: null,
                },
                email: '',
                phone: '',
                checking: true,
                alternative: false,
                provinces: [],
                provinces2: [],
                towns: [],
                towns2: [],
                postalCodes: [],
                postalCodes2: [],
                today: null,
                charge_label: null,
                strings: ['registeredAt'],
                arrays: ['emails', 'phones'],
            }
        },
        computed: {
            managementModels() {
                return getManagementModelsOptions();
            },
            mainAddress() {
                return {
                    name: 'Principal',
                    address: this.tempData.address,
                    province: this.tempData.province,
                    town: this.tempData.town,
                    postalCode: String(this.tempData.postalCode),
                    main: true
                }
            },
            secondAddress() {
                return {
                    name: this.tempData2.name,
                    address: this.tempData2.address,
                    province: this.tempData2.province,
                    town: this.tempData2.town,
                    postalCode: this.tempData2.postalCode,
                    main: false
                }
            },
            entityRegisteredAtFormatted: {
                get() {
                    return new Date(this.entity.registeredAt)
                },
                set(newValue) {
                    this.entity.registeredAt = moment(newValue, 'DD/MM/YYYY').format('YYYY-MM-DD');
                }
            },
        },
        mounted() {
            let self = this;
            this.today = new Date();
            self.entity = Object.assign({}, this.entity, this.partner);

            if (this.partner.registeredAt) {
                this.entity.registeredAt = moment(this.partner.registeredAt).format('YYYY-MM-DD');
            }
            if (this.entity.addresses[0]) {
                this.tempData = Object.assign({}, this.tempData, this.entity.addresses[0]);
            }
            if (this.entity.addresses[1]) {
                this.tempData2 = Object.assign({}, this.tempData2, this.entity.addresses[1]);
            }

            if (this.partner.clientCampaignTypes) {
                this.entity.campaignTypes = this.partner.clientCampaignTypes
                    .filter(campaignType => campaignType.unsubscribe == 1)
                    .map(campaignType => ({
                        uuid: campaignType.campaignType.uuid,
                        name: campaignType.campaignType.name
                    }));
            }
        },
        methods: {
            store(e) {
                if (e.preventDefault()) {
                    return;
                }

                this.$_loadingMixin_showLoading();
                let self = this;
                this.entity.addresses = [];
                this.entity.addresses.push(this.mainAddress);
                if (this.validateState('phone')) {
                    this.addPhone(this.phone);
                }
                if (this.validateState('email')) {
                    this.addEmail(this.email);
                }
                if (this.secondAddress.name && this.secondAddress.address && this.secondAddress.province && this.secondAddress.town && this.secondAddress.postalCode) {
                    this.entity.addresses.push(this.secondAddress);
                }

                this.entity.campaignTypes = this.entity.campaignTypes.map(campaign => campaign.uuid);

                try {
                    request('/members/' + this.partner.uuid + '/steps/2', 'post', 200, this.entity).then(x => {
                        self.setPartner(x);
                        self.$_loadingMixin_hideLoading();
                    });
                } catch (error) {
                    console.log(error);
                }
            },
            addPhone(number) {
                if (form.phone(number)) {
                    this.entity.phones.push({phone: number})
                    this.phone = ""
                }
            },
            addEmail(emailVal) {
                let email2 = {
                    email: '',
                    status: '',
                    main: false
                };

                if (form.email(emailVal)) {
                    if (this.entity.emails.length == 0) {
                        email2.email = emailVal;
                        email2.main = true;
                        email2.status = 'ACTIVE';
                    } else {
                        email2.email = emailVal;
                        email2.main = false;
                        email2.status = 'ACTIVE';
                    }
                    this.entity.emails.push(email2);
                    this.email = null;
                }
            },
            changeEmailStatus(email) {
                this.entity.emails.find(e => {
                    if (e.email == email) {
                        switch (e.status) {
                            case 'ACTIVE':
                                e.status = 'UNWANTED';
                                break;
                            case 'UNWANTED':
                                e.status = 'WRONG';
                                break;
                            default:
                                e.status = 'ACTIVE';
                        }
                        return e
                    }
                });
            },
            removeEmail(email) {
                this.entity.emails = this.entity.emails.filter(function (e) {
                    return e.email !== email;
                })
            },
            removePhone(phone) {
                this.entity.phones = this.entity.phones.filter(function (e) {
                    return e.phone !== phone;
                })
            },
            async requests(path, method, okCode, entity) {
                this[entity] = await request(path, method, okCode);
            },
            getValidateRulesForArrayField(entityProp, rules) {
                if (this.entity[entityProp] && this.entity[entityProp].length && rules.hasOwnProperty('required')) {
                    delete rules.required;
                }

                return rules;
            },
            validate() {
                if (this.strings.filter(string => !this.entity[string]).length > 0) {
                    return false;
                }
                if (this.arrays.filter(array => this.entity[array].length == 0).length > 0) {
                    return false;
                }
                if (!this.mainAddress.province || !this.mainAddress.town || !this.mainAddress.postalCode || !this.mainAddress.address) {
                    return false;
                }
                if (this.errors.items.length > 0) {
                    return false;
                }
                return true;

            },
            setPartner(entity) {
                this.$emit('sendPartner', entity);
            },
        }
    }
</script>
